/**
 * 表格基础方法，供表格继承
 * hanzb
 * 2019年5月10日，从表格组件移出至此
 */

"use strict"
import { sgiFormCtlCheck } from "./sgiFormCtlValidator"
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';


var sgiTableBaseFun = {

    /**
     * 获取表格所有数据
     * @return {[list]} [description]
     */
    getTbData: function () {
        return this.state.dataSource;
    },

    /**
     * [获取表格已选中/已勾选数据]
     * @return {[obj/list]} [已选中对象/已勾选行对象数组]
     */
    getTbSels: function () {
        return this.state.selectedRows;
    },

    /**
     * 表格设置 默认选中数据
     */
    setTbSels: function (records) {
        this.state.rowSelection.selectedRowKeys = []
        if (records instanceof Array) {
            records.forEach(element => {
                this.state.rowSelection.selectedRowKeys.push(element._key);
            });
        } else {
            this.state.rowSelection.selectedRowKeys = [records._key];
        }
        this.setState({ selectedRows: records });
    },

    /**
     * 根据普通数据 和对比属性，返回
     */
    getTbDataByKey: function (records, key) {
        let rsList = [];
        if (!records || !key) {
            return rsList;
        }
        let inList;
        let tmpTreeRecord;

        if (records instanceof Array) {
            inList = records;
        } else {
            inList = [records];
        }

        inList.forEach(inElement => {
            if (!inElement) return;
            for (var i = 0; i < this.state.dataSource.length; i++) {
                tmpTreeRecord = this.state.dataSource[i];
                if (tmpTreeRecord[key] == inElement[key]) {
                    rsList.push(tmpTreeRecord);
                    break;
                }
            }
        });
        return rsList;
    },

    /**
     * 向表格中添加新数据
     * @param {[type]} newData [要添加的数据]
     */
    addTbNewData: function (newData) {
        if (newData) {
            this.state.dataSource.push(newData);
            this.refreshTable(this.state.dataSource);

            //如果当前是分批调用表格，重新查询当页数据和总数
            if (this.state.batchInfo.batchFun) {
                this.state.pagination.total = 0;
                this.batchSelect();
            }
        }
    },

    /**
     * 删除表格选中数据
     * @return {[type]} [description]
     */
    delTableSel: function () {
        var selectedRows = this.getTbSels();
        var dataSource = this.state.dataSource;
        if (dataSource && selectedRows) {
            selectedRows.map((item, index) => {
                for (var i = 0; i < dataSource.length; i++) {
                    if (item == dataSource[i]) {
                        dataSource.splice(i, 1);
                    }
                }
            });
            this.refreshTable(dataSource);
            this.state.selectedRows = [];//既然删除了那就置空喽
            if (this.state.rowSelection) {
                this.state.rowSelection.selectedRowKeys = [];
            }
            return dataSource;
        } else {
            return null;
        }
    },

    /**
     * 删除表格指定行数据
     * @param  {[type]} delData [description]
     * @return {[type]}          [description]
     */
    delTableObj: function (delData) {
        var dataSource = this.state.dataSource;
        if (dataSource && delData) {
            for (var i = 0; i < dataSource.length; i++) {
                if (delData == dataSource[i] || delData._key == dataSource[i]._key) {
                    dataSource.splice(i, 1);
                }
            }
            this.refreshTable(dataSource);

            //如果当前是分批调用表格，重新查询当页数据和总数
            if (this.state.batchInfo.batchFun) {
                this.state.pagination.total = 0;
                this.batchSelect();
            }

            return dataSource;
        } else {
            return null;
        }
    },

    // 外部调用筛选方法
    filter: function (matStr, notContain) {
        if (matStr) {
            this.state.selValues.mat = matStr;
            this.state.contain = !notContain;
            let reg = new RegExp(matStr, 'gi');
            this.state.store = this.state.dataSource.filter(e => this._match(e, reg));
        } else {
            this.state.store = this.state.dataSource;
        }
        this.setState({ loading: false });//刷新
    },

}
export { sgiTableBaseFun }



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTableBaseFun.js